module.exports = __webpack_public_path__ + "img/imagepreview.d7334237.svg";